module.exports = __webpack_public_path__ + "img/169-97729f.png";